import {
  Button,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  TimePicker,
  Tooltip,
} from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconDelete from '../../../assets/images/schedules/icon-delete-segment.svg';
import iconPlus from '../../../assets/images/schedules/icon-plus.svg';
import { TYPE_PRICE_DOWN, TYPE_PRICE_UP } from '../../../config/constant';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { pickupLocationSelector } from '../../../redux/slice/pickupLocationSlice';
import { ListScheduleSelector, setListTransships } from '../../../redux/slice/schdules/scheduleSlice';
import '../../schedules/Schedules.scss';

const LocationModal: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  loading,
  segmentActive,
  isLastItem,
  listTransships,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [formLocation] = Form.useForm();
  const { listPickUpTransfer } = useAppSelector(pickupLocationSelector);
  const { listScheduleDetail, listSegment } = useAppSelector(ListScheduleSelector);
  const dispatch = useAppDispatch();
  const renderPickupLocations = () => {
    const filteredOptions = listPickUpTransfer
      .map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      })
      .filter((option) => option !== null);

    return filteredOptions;
  };
  const pickupLocationOption: void | any[] = listPickUpTransfer?.length ? renderPickupLocations() : [];
  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    formLocation.resetFields();
    onCancel();
  };

  const filterOptionPickup = (
    input: string,
    option?: {
      label: string;
      value: string;
    },
  ) => (option?.label ?? '').toLowerCase()?.includes(input.toLowerCase());
  const renderTitleLocation = () => {
    const isFirstItem = segmentActive[0]?.no === 1;
    if (segmentActive[0]?.no === 1) {
      return 'Điểm đầu:';
    } else if (!isFirstItem && isLastItem) {
      return 'Điểm cuối:';
    } else {
      return 'Điểm dừng:';
    }
  };

  const onFinish = (values: any) => {
    const updatedTransships = { ...listTransships };
    const transformedTransships = values.transships.map((item: any) => ({
      pickup_location_id: item.pickup_location,
      pickup_time: dayjs(item.pickup_time).format('HH:mm'),
      diff_day: item.diff_day,
      location_name: segmentActive[0]?.name,
      name: segmentActive[0]?.name,
      depart: isLastItem
        ? null
        : item.is_depart
        ? {
            is_extra_price: item.is_extra_price_depart,
            extra_price_value: item.extra_price_value_depart ? item.extra_price_value_depart : 0,
          }
        : null,
      arrive:
        segmentActive[0]?.no === 1
          ? null
          : item.is_arrive
          ? {
              is_extra_price: item.is_extra_price_arrive,
              extra_price_value: item.extra_price_value_arrive ? item.extra_price_value_arrive : 0,
            }
          : null,
    }));
    const matchingKey = Object.entries(listTransships).reduce((acc: any, [key, value]: any) => {
      if (value.find((transship: any) => transship.name === segmentActive[0]?.name)) {
        acc = key;
        return acc;
      }
      return acc;
    }, null);
    updatedTransships[matchingKey] = transformedTransships;
    dispatch(setListTransships(updatedTransships));
    modalHandleCancel();
    formLocation.resetFields();
  };
  useEffect(() => {
    const targetName = segmentActive[0]?.name;
    let transshipData: any = [];
    if (targetName) {
      transshipData = Object.values(listTransships)
        .flat()
        .filter((item: any) => item?.location_name === targetName);
    }
    if (transshipData.length > 0) {
      const transshipsArray = transshipData
        ?.map((item: any) => {
          if (item && item?.pickup_location_id) {
            return {
              pickup_location: item.pickup_location_id,
              pickup_time: item.pickup_time ? dayjs(item.pickup_time, 'HH:mm') : null,
              location_name: item.location_name,
              diff_day: item.diff_day || 0,
              is_depart: !!item.depart,
              is_arrive: !!item.arrive,
              is_extra_price_depart: item.depart?.is_extra_price || 0,
              extra_price_value_depart: item.depart?.extra_price_value || 0,
              is_extra_price_arrive: item.arrive?.is_extra_price || 0,
              extra_price_value_arrive: item.arrive?.extra_price_value || 0,
            };
          }
          return null;
        })
        .filter(Boolean);
      formLocation.setFieldsValue({ transships: transshipsArray });
    }
  }, [segmentActive, listTransships, formLocation]);
  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      centered
      width={1081}
      maskClosable={false}
      footer={
        <>
          <Row className="d-flex justify-content-end mt-5">
            <Button
              loading={loading}
              key="cancel"
              className="  w-160 h-btn-48 me-3"
              onClick={() => modalHandleCancel()}
            >
              Đóng
            </Button>
            <Button
              key="submit"
              type="primary"
              loading={loading}
              className="w-160 h-btn-48 btn-success mr-0"
              htmlType="submit"
              onClick={formLocation.submit}
              // onClick={() => handleUpdateLocation()}
            >
              Lưu
            </Button>
          </Row>
        </>
      }
      className="modal-segment-block booking-schedule-modal "
      styles={{ body: { maxHeight: '650px', overflowY: 'auto', overflowX: 'hidden', paddingBottom: '30px' } }}
    >
      <Flex className="segment-header">
        <h5 className="fw-600 fs-18 title">
          {`${renderTitleLocation()} ${segmentActive[0]?.name} (${
            segmentActive[0]?.arrive_time ? segmentActive[0]?.arrive_time : ''
          })`}
        </h5>
      </Flex>
      <Form
        name="segment-setting-form"
        layout="vertical"
        form={formLocation}
        onFinish={onFinish}
        colon={false}
        validateTrigger="onSubmit"
        initialValues={{
          transships: [
            {
              is_depart: true,
              is_arrive: true,
              pickup_time: dayjs().startOf('day').hour(0).minute(0),
              is_extra_price_arrive: TYPE_PRICE_UP,
              is_extra_price_depart: TYPE_PRICE_UP,
              extra_price_value_depart: 0,
              extra_price_value_arrive: 0,
            },
          ],
        }}
      >
        <div className="mt-3 border-b form-list-location">
          <Form.List name={`transships`}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key}>
                    <Row gutter={8} className="mt-3 block-segment-item location">
                      <Col span={6}>
                        <p className="label-input">Tên điểm</p>
                        <Form.Item name={[name, 'location_name']} className="d-none" {...restField}>
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'pickup_location']}
                          className="form-item-name required pickup-location-select"
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              message: 'Vui lòng nhập tên điểm',
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const allLocations = getFieldValue(['transships']).map(
                                  (item: any) => item.pickup_location,
                                );
                                const duplicate =
                                  allLocations?.length && allLocations?.filter((loc: any) => loc === value).length > 1;
                                if (duplicate) {
                                  return Promise.reject(new Error('Điểm đón trả này đã được chọn'));
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            className="input-h36 w-100 mt-1"
                            showSearch
                            placeholder={'Chọn điểm đón trả'}
                            size="large"
                            filterOption={filterOptionPickup}
                            options={pickupLocationOption}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={5}>
                        <p className="label-input">{segmentActive[0]?.no === 1 ? 'Giờ đi' : 'Giờ đến'} </p>
                        <Row className="mt-1">
                          <Col span={9}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pickup_time']}
                              className="form-item-name arrive-location"
                              rules={[
                                {
                                  required: true,
                                  message: 'Vui lòng nhập giờ đến',
                                },
                              ]}
                              validateTrigger={['onChange', 'onBlur']}
                            >
                              <TimePicker
                                suffixIcon={null}
                                showNow={false}
                                needConfirm={false}
                                style={{ minHeight: '40px' }}
                                format={'HH:mm'}
                                placeholder="00:00"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={15}>
                            <Form.Item
                              {...restField}
                              name={[name, 'diff_day']}
                              className="form-item-name form-item__diff_day required diff-day diff-day-location"
                              initialValue={0}
                            >
                              <Select
                                options={[
                                  { value: 0, label: 'Trong ngày' },
                                  { value: 1, label: '1 ngày sau' },
                                  { value: 2, label: '2 ngày sau' },
                                ]}
                              ></Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      {!isLastItem ? (
                        <Col xs={24} md={6}>
                          <Form.Item
                            {...restField}
                            name={[name, 'is_depart']}
                            valuePropName="checked"
                            className="is-depart"
                            validateTrigger={['onChange', 'onBlur']}
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  const isDepart = value;
                                  const isArrive = formLocation.getFieldValue(['transships', name, 'is_arrive']);
                                  if (!isDepart && !isArrive) {
                                    callback('Vui lòng chọn đón hoặc trả');
                                  } else {
                                    callback();
                                  }
                                },
                              },
                            ]}
                          >
                            <Checkbox
                              className="label-input"
                              disabled={segmentActive[0]?.no === 1}
                              onChange={(e) => {
                                if (!e.target.checked) {
                                  formLocation.setFieldValue(['transships', name, 'is_extra_price_depart'], undefined);
                                } else {
                                  formLocation.setFieldValue(
                                    ['transships', name, 'is_extra_price_depart'],
                                    TYPE_PRICE_UP,
                                  );
                                }
                              }}
                            >
                              Điểm đón
                            </Checkbox>
                          </Form.Item>

                          <Form.Item
                            name={[name, 'extra_price_value_depart']}
                            className={`extra-price-block form-item-name required extra_price price-location-input ${
                              !formLocation.getFieldValue(['transships', name, 'is_depart']) ? 'disabled' : ''
                            }`}
                            style={{ marginTop: '4px' }}
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Flex className="input-flex-container component" gap={0} align="center" vertical={false}>
                              <Form.Item
                                name={[name, 'is_extra_price_depart']}
                                validateTrigger={['onChange', 'onBlur']}
                              >
                                <Radio.Group size="small">
                                  <Radio.Button
                                    value={TYPE_PRICE_UP}
                                    disabled={!formLocation.getFieldValue(['transships', name, 'is_depart'])}
                                  >
                                    {t('Tăng')}
                                  </Radio.Button>
                                  <Radio.Button
                                    value={TYPE_PRICE_DOWN}
                                    disabled={!formLocation.getFieldValue(['transships', name, 'is_depart'])}
                                  >
                                    {t('Giảm')}
                                  </Radio.Button>
                                </Radio.Group>
                              </Form.Item>
                              <Divider type="vertical" />
                              <Form.Item
                                {...restField}
                                name={[name, 'extra_price_value_depart']}
                                className="form-item-name required"
                                validateTrigger={['onChange', 'onBlur']}
                              >
                                <InputNumber<number>
                                  disabled={!formLocation.getFieldValue(['transships', name, 'is_depart'])}
                                  // value={
                                  //   formLocation.getFieldValue(['transships', name, 'extra_price_value_depart']) || 0
                                  // }
                                  controls={false}
                                  formatter={(value) => {
                                    const numValue = value ? value.toString().replace(/,/g, '') : '0';
                                    return `${numValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                  }}
                                  parser={(value) => value?.replace(/[^0-9]/g, '') as unknown as number}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  addonAfter={
                                    <span style={{ color: '#949494' }} className="fs-16 font-normal">
                                      đ
                                    </span>
                                  }
                                  placeholder=""
                                />
                              </Form.Item>
                            </Flex>
                          </Form.Item>
                        </Col>
                      ) : (
                        ''
                      )}
                      {segmentActive[0]?.no !== 1 ? (
                        <Col
                          xs={24}
                          md={6}
                          className={`extra-price-block ${
                            !formLocation.getFieldValue(['transships', name, 'is_arrive']) ? 'disabled' : ''
                          }`}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'is_arrive']}
                            className="is-depart"
                            valuePropName="checked"
                            validateTrigger={['onChange', 'onBlur']}
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  const isDepart = formLocation.getFieldValue(['transships', name, 'is_depart']);
                                  const isArrive = value;
                                  if (!isDepart && !isArrive) {
                                    callback('Vui lòng chọn đón hoặc trả');
                                  } else {
                                    callback();
                                  }
                                },
                              },
                            ]}
                          >
                            <Checkbox
                              className="label-input"
                              disabled={isLastItem}
                              onChange={(e) => {
                                if (!e.target.checked) {
                                  formLocation.setFieldValue(['transships', name, 'is_extra_price_arrive'], undefined);
                                } else {
                                  formLocation.setFieldValue(
                                    ['transships', name, 'is_extra_price_arrive'],
                                    TYPE_PRICE_UP,
                                  );
                                }
                              }}
                            >
                              Điểm trả
                            </Checkbox>
                          </Form.Item>
                          <Form.Item
                            name={[name, 'extra_price_value_arrive']}
                            className="form-item-name required extra_price price-location-input"
                            style={{ marginTop: '6px' }}
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Flex className="input-flex-container component" gap={0} align="center" vertical={false}>
                              <Form.Item
                                name={[name, 'is_extra_price_arrive']}
                                validateTrigger={['onChange', 'onBlur']}
                              >
                                <Radio.Group size="small">
                                  <Radio.Button
                                    value={TYPE_PRICE_UP}
                                    disabled={!formLocation.getFieldValue(['transships', name, 'is_arrive'])}
                                  >
                                    {t('Tăng')}
                                  </Radio.Button>
                                  <Radio.Button
                                    value={TYPE_PRICE_DOWN}
                                    disabled={!formLocation.getFieldValue(['transships', name, 'is_arrive'])}
                                  >
                                    {t('Giảm')}
                                  </Radio.Button>
                                </Radio.Group>
                              </Form.Item>
                              <Divider type="vertical" />
                              <Form.Item
                                name={[name, 'extra_price_value_arrive']}
                                className="form-item-name required"
                                validateTrigger={['onChange', 'onBlur']}
                              >
                                <InputNumber
                                  formatter={(value) => {
                                    const numValue = value ? value.toString().replace(/,/g, '') : '0';
                                    return `${numValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                  }}
                                  disabled={!formLocation.getFieldValue(['transships', name, 'is_arrive'])}
                                  addonAfter={
                                    <span style={{ color: '#949494' }} className="fs-16 font-normal">
                                      đ
                                    </span>
                                  }
                                  placeholder={''}
                                  parser={(value) => value?.replace(/[^0-9]/g, '') as unknown as number}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Flex>
                          </Form.Item>
                        </Col>
                      ) : (
                        ''
                      )}
                      <Col style={{ height: '40px', marginTop: '28px' }} span={1}>
                        <Tooltip title="Xóa">
                          <Button type="text" onClick={() => remove(name)} className="p-0 btn-delete-segment">
                            <Image width={16} height={16} src={iconDelete} preview={false} />
                          </Button>
                        </Tooltip>
                      </Col>
                    </Row>
                  </div>
                ))}
                <Button
                  htmlType="button"
                  onClick={() =>
                    add({
                      is_depart: true,
                      is_arrive: true,
                      is_extra_price_arrive: TYPE_PRICE_UP,
                      is_extra_price_depart: TYPE_PRICE_UP,
                      extra_price_value_depart: 0,
                      extra_price_value_arrive: 0,
                      pickup_time: undefined,
                      diff_day: 0,
                    })
                  }
                  className="border-none text-success gap-x-8 d-flex items-center mt-2"
                  style={{ paddingLeft: 0 }}
                >
                  Thêm điểm đón trả
                  <img src={iconPlus} alt="" />
                </Button>
              </>
            )}
          </Form.List>
        </div>
      </Form>
    </Modal>
  );
};

export default LocationModal;
